import { useEffect } from 'react';

const MetaTagManager = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'article',
  author,
  publishedTime,
  readTime 
}) => {
  useEffect(() => {
    // Update document title
    if (title && title !== 'undefined' && title !== 'null' && title.trim() !== '') {
      document.title = title;
    } else {
      // Fallback to default title from branding
      const defaultTitle = 'ThreadShare';
      document.title = defaultTitle;
      console.warn('MetaTagManager: Using fallback title due to invalid title:', title);
    }

    // Helper function to update or create meta tag
    const updateMetaTag = (property, content, isName = false) => {
      if (!content) return;
      
      const selector = isName ? `meta[name="${property}"]` : `meta[property="${property}"]`;
      let metaTag = document.querySelector(selector);
      
      if (metaTag) {
        metaTag.setAttribute('content', content);
      } else {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(isName ? 'name' : 'property', property);
        metaTag.setAttribute('content', content);
        document.head.appendChild(metaTag);
      }
    };

    // Update basic meta tags
    updateMetaTag('description', description, true);
    updateMetaTag('author', author, true);
    
    // Update Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);
    
    if (publishedTime) {
      updateMetaTag('article:published_time', publishedTime);
    }
    if (author) {
      updateMetaTag('article:author', author);
    }
    if (readTime) {
      updateMetaTag('article:tag', `${readTime} read`);
    }
    
    // Update Twitter Card tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    updateMetaTag('twitter:url', url);
    updateMetaTag('twitter:card', 'summary_large_image');
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (url) {
      if (canonicalLink) {
        canonicalLink.setAttribute('href', url);
      } else {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('href', url);
        document.head.appendChild(canonicalLink);
      }
    }

    // Cleanup function to restore original meta tags when component unmounts
    return () => {
      // You could implement cleanup here if needed
      // For now, we'll leave the updated meta tags in place
    };
  }, [title, description, image, url, type, author, publishedTime, readTime]);

  return null; // This component doesn't render anything
};

export default MetaTagManager;